import React from 'react';
import { findDOMNode } from 'react-dom';
import { isBrowser } from "react-device-detect";
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(Partners) {
        this.PartnersNode = findDOMNode(Partners);
        this.logos = [...this.PartnersNode.querySelectorAll('.logo-col img')];

        const oddNumbers = this.logos.filter((value, key) => key % 2 !== 0);
        const evenNumbers = this.logos.filter((value, key) => key % 2 === 0);

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite(),
            logoTl = new TimelineLite({
                onComplete: function() {
                    setTimeout(() => {
                        this.restart();
                    }, 2000);
                }
            });

        if (Partners.subTitleRef) {
            tl.fromTo(Partners.subTitleRef, 1, globals.getSubAnimation(Partners.subTitleRef), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)});
        }

        if (isBrowser) {
            logoTl.add('cycleOutOdd', "+=0.5");
            logoTl.staggerFromTo(oddNumbers, 0.3, {y: 0, opacity: 1}, {y: 50, opacity: 0}, 0.2, 'cycleOutOdd');
            logoTl.staggerFromTo(evenNumbers, 0.3, {y: -50, opacity: 0}, {y: 0, opacity: 1}, 0.2, 'cycleOutOdd');
            logoTl.add('cycleOutEven', "+=2");
            logoTl.staggerTo(evenNumbers, 0.3, {y: 50, opacity: 0}, 0.2, 'cycleOutEven');
            logoTl.staggerTo(oddNumbers, 0.3, {y: 0, opacity: 1}, 0.2, 'cycleOutEven');
        }

        new ScrollMagic.Scene({
            triggerElement: '.partners-trigger',
            reverse: false
        })
            .setTween([tl, logoTl])
            .addTo(controller);

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Partners/animations.js